export const DishabledDetialRouting = [
  {
    hidden: true,
    path: "/dashboard/enterpriseAnnouncement/detail/:id",
    name: "dashboard-enterpriseAnnouncement-detail",
    meta: { title: "查看企业公告" },
    component: () =>
      import(
        /* webpackChunkName: "tender-apply" */ "@/views/dashboard/detail/enterpriseAnnouncement/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/dashboard/rulesAndRegulations/detail/:id",
    name: "dashboard-rulesAndRegulations-detail",
    meta: { title: "查看规章制度" },
    component: () =>
      import(
        /* webpackChunkName: "tender-apply" */ "@/views/dashboard/detail/rulesAndRegulations/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/dashboard/viewNews/detail/:id",
    name: "dashboard-ViewNews-detail",
    meta: { title: "查看新闻" },
    component: () =>
      import(/* webpackChunkName: "tender-apply" */ "@/views/dashboard/detail/viewNews/index.vue"),
  },
  {
    hidden: true,
    path: "/dashboard/detail/companyNoticeDetails/:id",
    name: "company-notice-details",
    meta: { title: "查看企业通知" },
    component: () =>
      import(
        /* webpackChunkName: "tender-apply" */ "@/views/dashboard/detail/company-notice-details/index.vue"
      ),
  },
];
